import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-primary-column-line',
  templateUrl: './primary-column-line.component.html',
  styleUrls: ['./primary-column-line.component.scss']
})
export class PrimaryColumnLineComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/common-module/components/primary-column-line/primary-column-line.component.ts